function Link(): any {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover'
      }
    }
  };
}

export { Link };
